import { render } from "./ImAgGrid.vue?vue&type=template&id=50b8533f"
import script from "./ImAgGrid.vue?vue&type=script&lang=js"
export * from "./ImAgGrid.vue?vue&type=script&lang=js"

import "./ImAgGrid.vue?vue&type=style&index=0&id=50b8533f&lang=css"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__